export default __webpack_public_path__ + "c1301f69ffc7fee771ff3c6f29afd8ce.png";